import React from 'react'

const PasswordLoading = () => (
    <div className="jm-pwd-loading">
        <div className="jm-content-light">
            <p>Bitte warten</p>
        </div>
    </div>
)

export default PasswordLoading
